/**
 * jQuery 플러그인 초기화 유틸리티
 * React 컴포넌트가 마운트된 후에 jQuery 플러그인들을 초기화
 */

export const initJQueryPlugins = () => {
  // jQuery가 로드되었는지 확인
  if (typeof window.jQuery === 'undefined') {
    console.warn('jQuery가 아직 로드되지 않았습니다.');
    return;
  }

  const $ = window.jQuery;

  // DOM이 준비되었는지 확인하고 초기화
  const init = () => {
    // scrollUp 플러그인은 React의 ScrollToTop 컴포넌트로 대체되었으므로
    // jQuery 플러그인 초기화는 완전히 비활성화
    // React 컴포넌트가 아닌 기존 jQuery로 생성된 버튼 제거
    const existingButtons = $('#scrollUp').filter(function() {
      return !$(this).attr('data-react-component');
    });
    if (existingButtons.length > 0) {
      existingButtons.remove();
    }

    // 다른 jQuery 플러그인들 초기화
    if ($.fn.niceSelect && $('.nice-select').length > 0) {
      try {
        $('.nice-select').niceSelect();
      } catch (e) {
        console.warn('niceSelect 초기화 실패:', e);
      }
    }

    if ($.fn.select2 && $('.select2').length > 0) {
      try {
        $('.select2').select2();
      } catch (e) {
        console.warn('select2 초기화 실패:', e);
      }
    }
  };

  // DOM이 준비되면 즉시 실행, 아니면 약간의 지연 후 실행
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // 이미 로드되었으면 약간의 지연 후 실행 (React 렌더링 대기)
    setTimeout(init, 100);
  }
};

/**
 * React 컴포넌트 마운트 후 jQuery 플러그인 초기화
 */
export const initJQueryPluginsAfterMount = () => {
  // React 렌더링 완료를 기다림
  setTimeout(() => {
    initJQueryPlugins();
  }, 200);
};

